import { TARIFFS } from '@enmon/commons';
import { SelectProps } from 'antd';
import { VFC, useMemo } from 'react';
import { Select } from './Select';

export const TariffSelect: VFC<SelectProps> = props => {
  const options = useMemo(
    () =>
      TARIFFS.map(tariff => ({
        value: tariff,
        label: tariff,
      })),
    [],
  );

  return <Select options={options} placeholder="1" {...props} className="w-100" dropdownMatchSelectWidth={false} />;
};
